import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Header_2 from '../headers/Header_2';
import TitleTextButton from '../modules/TitleTextButton';
import ProjektSlider from '../components/ProjektSlider';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import { Aktuelles } from './Aktuelles';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Button from '../components/Button';
import SEO from '../components/Seo';
import ThemenModule from '../modules/ThemenModule';

export const SozialesEngagement = () => {
    const [show, setShow] = useState(false);
    

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/soziales-engagement?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-1-titel-text][populate][PDF][populate][PDF]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate]=*&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Video]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Videominiatur]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF][populate][PDF]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Button]=true&populate[Metadaten]=*");



            // ?populate[Bannerbereich][on][header.header-1-titel-text][populate][Button]=true

            // &populate[Modul][on][modules.formulare-reglemente-dokumente][populate][Titel_Text]=*
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Video]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Videominiatur]=true
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF]=true
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft" activePage='genossenschaft' />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>

                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.projekte-portfolio" &&
                            <section className='pt-pb-10 sec-bg-grey sec-blue-color'>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel_Titel_Text_Button?.Kurztitel} title={module?.Kurztitel_Titel_Text_Button?.Titel} text={module?.Kurztitel_Titel_Text_Button?.Text} buttons={module?.Kurztitel_Titel_Text_Button?.Button} component={module?.Kurztitel_Titel_Text_Button?.Komponente} pdf={module?.Kurztitel_Titel_Text_Button?.PDF} />
                                    <ProjektSlider title={module?.Kurztitel_Titel_Text_Button?.Titel} text={module?.Kurztitel_Titel_Text_Button?.Text} buttons={module?.Kurztitel_Titel_Text_Button?.Button} projects={module?.neubauprojekte_posts} />
                                </div>
                            </section>}

                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="pink" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }

                        {module.__component === "modules.news" &&
                            <section className='pt-pb-10 sec-bg-grey sec-pink-color'>
                                <div className='container'>
                                    <Aktuelles shortTitle={module?.Kurztitel_Titel_Text_Button?.Kurztitel} title={module?.Kurztitel_Titel_Text_Button?.Titel} text={module?.Kurztitel_Titel_Text_Button?.Text} aktuelles={module?.aktuelles} />
                                </div>
                            </section>}
                        {module.__component === "modules.themenmodul-komplett" &&
                            <ThemenModule module={module} />
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

        </div>
    )
}